module.exports = __webpack_public_path__ + "img/a-back.d94572e1.png";